var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPurpleRainbow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 116,
    viewBox: "0 0 58 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0913 58C18.0913 80.041 35.959 97.9087 58 97.9087L58 87.7154C41.5886 87.7154 28.2846 74.4113 28.2846 58C28.2846 41.5886 41.5886 28.2846 58 28.2846L58 18.0913C35.959 18.0913 18.0913 35.959 18.0913 58Z",
    fill: "#DAB9E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.53526e-06 58C6.73582e-06 90.0325 25.9675 116 58 116L58 105.807C31.5971 105.807 10.1933 84.4029 10.1933 58C10.1933 31.5971 31.5971 10.1933 58 10.1933L58 -2.53526e-06C25.9675 1.6653e-06 -1.6653e-06 25.9675 2.53526e-06 58Z",
    fill: "#DAB9E2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3603 58C35.3603 70.5036 45.4964 80.6398 58 80.6398L58 70.4464C51.126 70.4464 45.5536 64.874 45.5536 58C45.5536 51.126 51.126 45.5536 58 45.5536L58 35.3603C45.4964 35.3603 35.3603 45.4964 35.3603 58Z",
    fill: "#DAB9E2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleRainbow);
export default __webpack_public_path__ + "static/media/purple-rainbow.a74837d7763f1b198f7348cda4c8c4e1.svg";
export { ForwardRef as ReactComponent };